import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Header from '../include/Header';
import Sidebar from '../include/Sidebar';
import axios from 'axios';
import { PAY_URL } from '../../../BaseURL';
import toast from 'react-hot-toast';

const ManageStorage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState('');
  const [selectValue, setSelectValue] = useState('');
  const [store, setStore] = useState({
    store_name: "",
    store_email: "",
    store_contact: "",
    store_address: "",
  })

  const data = location.state;
  // console.log(data, '@@')

  useEffect(() => {
    if (localStorage.getItem('PAY_ADMIN_TOKEN') === null) {
      navigate("/admin/login");
    }
  }, []);

  useEffect(() => {
    if (location.state) {

      setStore({
        store_name: location.state.store_name,
        store_email: location.state.store_email,
        store_contact: location.state.store_contact,
        store_address: location.state.store_address,
      })

      setSelectValue(location.state.status);
    }
  }, [location.state])

  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleChange = (e) => {
    setStore({ ...store, [e.target.name]: e.target.value })
  }

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true);

      const bodyFormData = new URLSearchParams();

      bodyFormData.append('store_name', store.store_name);
      bodyFormData.append('store_email', store.store_email);
      bodyFormData.append('store_contact', store.store_contact);
      bodyFormData.append('store_address', store.store_address);

      if (data?._id) {
        bodyFormData.append('id', data?._id)
        bodyFormData.append('status', selectValue)
      }
      axios({
        method: 'post',
        url: `${PAY_URL}/admin/manage-store`,
        data: bodyFormData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Authorization: "Bearer " + localStorage.getItem('PAY_ADMIN_TOKEN') }
      }).then((response) => {
        if (response.data.success === true) {
          toast.success(response.data.message)
          navigate('/admin/store-management');
        }
        setDisable(false);
      }).catch((error) => {
        console.log(error);
        toast.error(error.response.data.message);
        setDisable(false);
      })
    }
  }


  const validation = () => {
    var isValid = true;
    let err = {};

    if (!store.store_name || !store?.store_name?.trim()) {
      isValid = false;
      err['store_name_err'] = "Please enter name"
    }

    if (!store.store_email) {
      isValid = false;
      err['store_email_err'] = "Please enter email"
    } else if (typeof store.store_email !== "undefined") {
      let lastAtPos = store.store_email.lastIndexOf('@');
      let lastDotPos = store.store_email.lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && store.store_email.indexOf('@@') === -1 && lastDotPos > 2 && (store.store_email.length - lastDotPos) > 2)) {
        isValid = false;
        err["store_email_err"] = "Email is not valid";
      }
    }

    if (!store.store_contact) {
      isValid = false;
      err["store_contact_err"] = "Please enter mobile";
    } else if (!/^\d{10}$/.test(store.store_contact)) {
      isValid = false;
      err['store_contact_err'] = 'Please enter a valid mobile';
    }

    if (!store.store_address || !store?.store_address?.trim()) {
      isValid = false;
      err['store_address_err'] = "Please enter address"
    }

    setError(err);
    return isValid;
  }

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  }

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }


  return (
    <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">{data?._id ? 'Edit' : 'Add'} Store</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item"><Link to="/admin/dashboard">Dashboard</Link></li>
                  <li className="breadcrumb-item"><Link to="/admin/store-management">Store Management</Link></li>
                  <li className="breadcrumb-item active">{data?._id ? 'Edit' : 'Add'} Store</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card p-3 basicform">
            {/* <div className=" mb-3 titleForm border-bottom">
                    <h4>Bank</h4>
                </div> */}

            <div className="row card_id">
              <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control"
                      name='store_name' value={store.store_name} onChange={handleChange}
                    />
                    <div className='error'>{error.store_name_err}</div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control"
                      name='store_email' value={store.store_email} onChange={handleChange}
                    />
                    <div className='error'>{error.store_email_err}</div>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3">
                    <label className="form-label">Mobile</label>
                    <input type="number" className="form-control"
                      name='store_contact' value={store.store_contact} onChange={handleChange} onWheel={(e) => e.target.blur()}
                      onKeyDown={handleKeyDown}
                    />
                    <div className='error'>{error.store_contact_err}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className='row card_id'>

              <div className="col-md-12 col-lg-12 col-xxl-12 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <textarea type="text" className="form-control"
                      onChange={handleChange} name='store_address' value={store.store_address}
                    />
                    <div className='error'>{error.store_address_err}</div>
                  </div>
                </div>
              </div>

              {data?._id ? (
                <div className='col-md-4 col-lg-4 col-xxl-4 col-sm-12'>
                  <div className="cardNum">
                    <div className="mb-3">
                      <label htmlFor="fileUpload" className="form-label">Status</label>
                      <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" role="switch" onChange={handleRadioChange} checked={selectValue} />
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div className="row card_id mt-4 sm-mt-3">
              <div className=" col-md-4 col-lg-4 col-xxl-4 col-sm-12">
                <div className="cardNum">
                  <div className="mb-3 d-flex gap-2">
                    <button className="btn btn-primary w-50" type='button' onClick={handleSubmit} disabled={disable}>{disable ? "Processing..." : (data?._id ? 'Update' : 'Submit')}</button>
                    <button className="btn btn-outline-secondary w-50" type='button' onClick={() => setStore({
                      store_name: "",
                      store_email: "",
                      store_contact: "",
                      store_address: "",
                    })}>Reset</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ManageStorage